const $ = require('jQuery');
const { instance } = require('./models/machine_app_implementation_loader');
const styles = require('./machine_app_dev_reload_button.css');

const gDevReloadButton = $('<button>')
  .text('Reload MachineApps')
  .addClass('machine_app_dev_reload_button')
  .on('click', () => {
    gDevReloadButton.addClass('disabled');
    instance.loadLibrary(function() {
      gDevReloadButton.removeClass('disabled');
    });
  });

function refresh() {
  const lIsEnabled = localStorage.getItem('machine_app_local_bundle') != null;
  gDevReloadButton.detach();
  if (lIsEnabled) gDevReloadButton.appendTo('body');
}

refresh();

module.exports = {
  refresh
};